import React, { useState } from 'react';
import { FLOOR_NAMES, FLOOR_LABELS } from '../../constants';
import { AdminModal, AdminSelect } from '@project/components';
import { FaRegEdit } from 'react-icons/fa';
import styles from './ChangeFloorName.module.css';
import { useIntl } from 'react-intl';

const ChangeFloorName = ({ spaceProfile, currentFloor, saveProfile, setFloorData, floorData, isReadOnly }) => {
  const intl = useIntl();
  const t = (id) => intl.formatMessage({id});
  
  const getCurrentFloorName = profile => profile.floor_label ? { value: profile.floor_label, label: FLOOR_LABELS[profile.floor_label] || (profile.floor_label && intl.formatMessage({id: 'floorLabels.level'}, {level: profile.floor_label.split(' ')[1]})) } : null;

  const [isSaving, setIsSaving] = useState(false);
  const [showFloorNameModal, setShowFloorNameModal] = useState(false);
  const [selectedFloorName, setSelectedFloorName] = useState(getCurrentFloorName(spaceProfile));

  // build the options for the floor name dropdown
  const floorNameOptions = [];
  FLOOR_NAMES.forEach(_ => floorNameOptions.push({value: _, label: FLOOR_LABELS[_]}))
  for (let i = 1; i < 100; i++) floorNameOptions.push({value: `Level ${i}`, label: intl.formatMessage({id: 'floorLabels.level'}, {level: i})});

  const closeFloorNameModal = () => {
    setShowFloorNameModal(false);
    setSelectedFloorName(getCurrentFloorName(spaceProfile));
  }

  const saveFloorName = async () => {
    setIsSaving(true);
    spaceProfile.floor_label = selectedFloorName.value;
    await saveProfile(true, () => {
      const currentFloorData = floorData.find(_ => parseInt(_.floor) === parseInt(currentFloor));
      if (currentFloorData) {
        currentFloorData.floor_label = spaceProfile.floor_label;
        setFloorData([...floorData]);
      } else {
        setFloorData([{guid: spaceProfile.guid, floor: currentFloor, floor_label: spaceProfile.floor_label}]);
      }     
      closeFloorNameModal();
    });
    setIsSaving(false);
  }

  if (isReadOnly) return null;

  return (
    <>
      <FaRegEdit className={`${styles.editFloorIcon} ml-3 align-self-center`} onClick={() => setShowFloorNameModal(true)} />
      <AdminModal title={t('ChangeFloorName.title')} show={showFloorNameModal} onHide={closeFloorNameModal} onSave={saveFloorName} isSaving={isSaving} >
        <AdminSelect label="" defaultValue="" value={selectedFloorName} onChange={setSelectedFloorName} options={floorNameOptions} placeholder={`${t('ui.select')}...`} />
      </AdminModal>
    </>
  )
}

export default ChangeFloorName;